import { Platform } from "react-native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { ClickClass } from "../pages/ClickClass";
import { Video } from "../pages/Video";
import { ClickCard } from "../pages/ClickCard";
import { LiveStream } from "../pages/LiveStream";
import { PDFView } from "../pages/PDFView";
import { About } from "../pages/About";
import { Main } from "../pages/Main";
import { ClickCourse } from "../pages/ClickCourse";
import { TermsofUse } from "../pages/TermsofUse";
import { Users } from "../pages/Users";
import { Comments } from "../pages/Comments";
import { DrawerContent } from "../components/DrawerContent";
import THEME from '../config/theme';
import { Plans } from "../pages/Plans";
import { EditProfile } from "../pages/EditProfile";
import { SignUp } from "../pages/SignUp";
import { BlixSignUp } from "../pages/BlixSignUp";
import { Products } from "../pages/AdminPanel/Products";
import { UsersAnalytics } from "../pages/Users/UserAnalytics";
import Community from '../pages/Community';
import { CommunityProvider } from '../pages/Community/ContextCommunity/CommunityContext';
import { CommunityCommentsScreen } from '../pages/Community/CommunityCommentsScreen';
import ProductConfig from "../pages/AdminPanel/Products/ProdutConfig";
import Checkout from "../pages/Checkout/Checkout";
import { ProductCatalog } from "../pages/ProductCatalog";
import { CustomLogin } from '../pages/CustomLogin';
import { AppMobile } from '../pages/AppMobile';
import { useCustomTheme } from '../contexts/useCustomTheme';
import { MyAccount } from '../pages/MyAccount';
import { Brand } from '../pages/Brand';
import { Features } from '../pages/AdminPanel/Features';
import { hasOutsideAboutPage } from "../config/data";
import Octicons from '@expo/vector-icons/Octicons';
import Notifications from "../pages/Notifications";
import PostCheckoutProduct from "../pages/Checkout/PostCheckoutProduct";

const Stack = createNativeStackNavigator();
const Drawer = createDrawerNavigator();


function DrawerRoutes({ user }) {
  const { customFont, customColor } = useCustomTheme();
  
  //adminRole "supportOnly" only allows access to notiications, community and comments
  const hasAdminRole = !user?.adminRole

  return (
    <Drawer.Navigator
      useLegacyImplementation={false}
      drawerContent={(props) => <DrawerContent {...props} />}
      screenOptions={{
        headerShown: false,
        drawerStatusBarAnimation: 'fade',

        // Sem escurecimento de fundo: como o drawer agora é fixo (position:fixed
        // na web), o overlay do react-native-paper continuava `absolute` no lado
        // do conteúdo que rola e ficava "cortado" ao rolar. Como uma barra lateral
        // fixa não precisa de backdrop, deixamos transparente.
        overlayColor: 'transparent',

        drawerActiveBackgroundColor:
          customColor && customColor.text && customColor.text.app
            ? customColor.text.app
            : THEME.COLORS.DRAWER_SELECTED,

        drawerActiveTintColor: customColor && customColor.background && customColor.background.app
          ? customColor.background.app
          : THEME.COLORS.BACKGROUND_ABOUT,

        drawerInactiveTintColor:
          customColor && customColor.text && customColor.text.app
            ? customColor.text.app
            : THEME.COLORS.DRAWER_SELECTED,

        drawerStyle: {
          backgroundColor: customColor && customColor.background && customColor.background.app
            ? customColor.background.app
            : THEME.COLORS.BACKGROUND_ABOUT,
          // Fixa o drawer na viewport na web: o painel é `position: absolute`
          // relativo ao container que rola junto com a página, então ao rolar
          // ele "subia". Com `position: fixed` (aplicado depois do estilo padrão
          // do @react-navigation/drawer) ele gruda na lateral esquerda e não
          // acompanha o scroll. A animação de abrir/fechar (translateX) continua
          // funcionando por ser um transform independente da posição.
          ...(Platform.OS === "web" ? { position: "fixed", height: "100vh" } : {}),
        },

        drawerLabelStyle: {
          fontSize: THEME.FONTSIZE.SMALL,
          fontFamily:
            customFont && customFont.fontFamilyText
              ? customFont.fontFamilyText
              : THEME.FONTFAMILY.REGULAR,
        },
      }}
    >
      <Drawer.Screen name="Conteudo" component={Main} />

      <Drawer.Screen name="Minha conta" component={MyAccount}
        options={{
          drawerIcon: ({ color }) => (
            <Octicons name="paintbrush" color={color} size={18} />
          ),
        }} />
      {hasAdminRole &&
        <Drawer.Screen name="Marca" component={Brand} options={{
          drawerIcon: ({ color }) => (
            <Octicons name="paintbrush" color={color} size={18} />
          ),
        }} />
      }
      {hasAdminRole &&
        <Drawer.Screen name="Tela de login" component={CustomLogin} options={{
          drawerIcon: ({ color }) => (
            <Octicons name="paintbrush" color={color} size={18} />
          ),
        }} />
      }
      {hasAdminRole &&
        <Drawer.Screen name="App Mobile" component={AppMobile} options={{
          drawerIcon: ({ color }) => (
            <Octicons name="device-mobile" color={color} size={18} />
          ),
        }} />
      }

      {hasAdminRole &&
        <Drawer.Screen name="Produtos" component={Products} />
      }
      {hasAdminRole &&
        <Drawer.Screen name="Alunos" component={Users} />
      }
      <Drawer.Screen name="Comentários" component={Comments} />
      {hasAdminRole &&
        <Drawer.Screen name="Funcionalidades" component={Features} />
      }
      <Drawer.Screen name="Termos de Uso">
        {() => <TermsofUse isAdmin={true} />}
      </Drawer.Screen>
    </Drawer.Navigator>
  );
}
const CommunityScreen = () => (
  <CommunityProvider>
    <Community />
  </CommunityProvider>
);

export function AdminRoutes({ user }) {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name="Admin">
        {(props) => <DrawerRoutes {...props} user={user} />}
      </Stack.Screen>
      <Stack.Screen name="Modulo" component={ClickCard} />
      <Stack.Screen name="Aula" component={ClickClass} />
      <Stack.Screen name="Watch" component={Video} />
      <Stack.Screen name="Live" component={LiveStream} />
      <Stack.Screen name="PDF" component={PDFView} />
      <Stack.Screen name="Produto" component={ClickCourse} />
      <Stack.Screen name="Página de Vendas" component={About} />
      {!hasOutsideAboutPage && <Stack.Screen name="Planos" component={Plans} />}
      <Stack.Screen name="Cadastro" component={SignUp} />
      <Stack.Screen name="Cadastro_Blix" component={BlixSignUp} />
      <Stack.Screen name="ProductConfig" component={ProductConfig} />
      <Stack.Screen name="MeuPerfil">
        {(props) => (
          <EditProfile
            {...props}
            userId={props.route.params.userId}
            editUserAccess={props.route.params.editUserAccess}
          />
        )}
      </Stack.Screen>
      <Stack.Screen name="PoliticaDePrivacidade" component={TermsofUse} initialParams={{ doc: "privacy" }} />
      <Stack.Screen name="UsersAnalytics" component={UsersAnalytics} />
      <Stack.Screen name="Community" component={CommunityScreen} />
      <Stack.Screen name="Checkout" component={Checkout} />
      <Stack.Screen name="PostCheckoutProduct" component={PostCheckoutProduct} />
      <Stack.Screen
        name="CommunityComments"
        component={CommunityCommentsScreen}
      />
      <Stack.Screen name="Notifications" component={Notifications} />
      <Stack.Screen name="CatalogoProdutos" component={ProductCatalog} />
    </Stack.Navigator>
  );
}